import React from 'react';
import styles from './O_CapsuleCreateHeaderMobile.module.css';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import A_CircleButton from '@/components/A_Atoms/A_CircleButton/A_CircleButton';
import { PATHS } from '@/constants/paths';
import { useNavigate } from 'react-router-dom';
import Q_BlurEffect from '@/components/Q_Quarks/Q_BlurEffect/Q_BlurEffect';

interface O_CapsuleCreateHeaderMobileProps {
  onOpenAddContent?: () => void;
  onOpenBurgerMenu?: () => void;
  onPreviewClick?: () => void;
  onPublishClick?: () => void;
  showPreviewButton?: boolean;
  isScenarioPreview?: boolean;
  showUploadButton?: boolean;
}

export default function O_CapsuleCreateHeaderMobile({
  onOpenAddContent,
  onOpenBurgerMenu,
  onPreviewClick,
  onPublishClick,
  showPreviewButton = false,
  isScenarioPreview = false,
  showUploadButton = false,
}: O_CapsuleCreateHeaderMobileProps) {
  const navigate = useNavigate();
  return (
    <header className={styles.wrapper}>
      <Q_BlurEffect yAxis='top' withBackground={false} />
      <A_CircleButton
        icon={
          <Q_Icon.ArrowLeftIcon
            width={14}
            height={27}
            stroke='currentColor'
            fill='none'
          />
        }
        size='small'
        variant='secondary'
        onClick={() => navigate(PATHS.CAPSULES)}
      />
      <div className={styles.center_wrapper}>
        {showUploadButton && !isScenarioPreview && (
          <A_CircleButton
            icon={<Q_Icon.PlusIcon width={18} height={18} fill='none' />}
            size='large'
            variant='primary'
            onClick={() => onOpenAddContent && onOpenAddContent()}
          />
        )}
        {showPreviewButton && (
          <A_CircleButton
            icon={<Q_Icon.PreviewIcon width={16} height={24} fill='none' />}
            size='large'
            variant='primary'
            onClick={() => onPreviewClick && onPreviewClick()}
          />
        )}
        {isScenarioPreview && onPublishClick && (
          <A_CircleButton
            icon={<Q_Icon.CheckmarkIcon width={20} height={20} fill='none' />}
            size='large'
            variant='primary'
            onClick={() => onPublishClick()}
          />
        )}
      </div>
      <A_CircleButton
        icon={<Q_Icon.BurgerIcon width={16} height={16} fill='currentColor' />}
        size='small'
        variant='secondary'
        onClick={() => onOpenBurgerMenu && onOpenBurgerMenu()}
      />
    </header>
  );
}
